<template>
  <div class="soporte-layout">
    <TopBarTitleComponent title="Soporte" :showBackIcon="true" />

    <div class="soporte-body">
      <div class="soporte-hero">
        <div class="soporte-hero__icon">
          <i class="el-icon-headset"></i>
        </div>
        <h2 class="soporte-hero__title">Centro de Soporte</h2>
        <p class="soporte-hero__desc">
          Estamos trabajando para brindarte la mejor experiencia de atención.
          Pronto tendrás acceso a todas estas herramientas.
        </p>
      </div>

      <div class="soporte-grid">
        <div v-for="module in modules" :key="module.key" class="soporte-card">
          <div class="soporte-card__icon-wrap">
            <i :class="module.icon"></i>
          </div>
          <div class="soporte-card__content">
            <span class="soporte-card__badge">Próximamente</span>
            <h3 class="soporte-card__title">{{ module.title }}</h3>
            <p class="soporte-card__desc">{{ module.desc }}</p>
          </div>
        </div>
      </div>

      <div class="soporte-chat-hint">
        <i class="el-icon-chat-dot-round"></i>
        <span
          >¿Necesitas ayuda ahora? Usa el botón de chat en la esquina inferior
          derecha.</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import TopBarTitleComponent from "@/modules/dashboard/components/TopBarTitle";
import { onLoadScriptSoporte } from "@/assets/utils/soporte";

export default {
  name: "SoportePage",
  components: { TopBarTitleComponent },
  data: () => ({
    modules: [
      {
        key: "tickets",
        icon: "el-icon-tickets",
        title: "Atención de Tickets",
        desc:
          "Crea y gestiona tickets de soporte. Haz seguimiento del estado de cada solicitud en tiempo real."
      },
      {
        key: "chat",
        icon: "el-icon-chat-line-round",
        title: "Chat en Vivo",
        desc:
          "Conecta directamente con nuestro equipo de soporte a través de chat instantáneo."
      },
      {
        key: "knowledge",
        icon: "el-icon-reading",
        title: "Base de Conocimiento",
        desc:
          "Accede a guías, tutoriales y preguntas frecuentes para resolver dudas por tu cuenta."
      },
      {
        key: "history",
        icon: "el-icon-time",
        title: "Historial de Soporte",
        desc:
          "Revisa el historial completo de todas tus consultas y soluciones anteriores."
      }
    ]
  }),
  mounted() {
    onLoadScriptSoporte();
    this._showWidget();
  },
  beforeDestroy() {
    this._hideWidget();
  },
  methods: {
    _showWidget() {
      const apply = () => {
        const el = document.querySelector(".amo-button-holder");
        if (el) {
          el.style.setProperty("display", "block", "important");
          el.style.setProperty("right", "16px", "important");
          el.style.setProperty("bottom", "16px", "important");
          el.style.setProperty("left", "auto", "important");
        }
      };
      apply();
      const observer = new MutationObserver(() => {
        if (document.querySelector(".amo-button-holder")) {
          apply();
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      [500, 1500, 3000].forEach(ms => setTimeout(apply, ms));
    },
    _hideWidget() {
      const el = document.querySelector(".amo-button-holder");
      if (el) el.style.setProperty("display", "none", "important");
    }
  }
};
</script>

<style scoped lang="scss">
$primary: #2d2b55;
$accent: #3ecfb4;
$border: #e4eaf6;
$bg: #f7f8fc;

.soporte-layout {
  min-height: 100vh;
  background: #fff;
}

.soporte-body {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 24px 60px;
}

// ── Hero ──
.soporte-hero {
  text-align: center;
  padding: 40px 20px 32px;

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 72px;
    height: 72px;
    border-radius: 20px;
    background: linear-gradient(135deg, #e8faf7 0%, #d0f5ee 100%);
    margin-bottom: 18px;

    i {
      font-size: 34px;
      color: $accent;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    color: $primary;
    margin: 0 0 10px;
  }

  &__desc {
    font-size: 14px;
    color: #6b7280;
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

// ── Grid ──
.soporte-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}

// ── Card ──
.soporte-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 14px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: box-shadow 0.15s;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  }

  &__icon-wrap {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: #f0fdf9;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 22px;
      color: $accent;
    }
  }

  &__badge {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #f59e0b;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 20px;
    padding: 2px 10px;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 15px;
    font-weight: 700;
    color: $primary;
    margin: 0 0 4px;
  }

  &__desc {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.5;
    margin: 0;
  }
}

// ── Chat hint ──
.soporte-chat-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 20px;
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  color: #6b7280;
  font-size: 13px;

  i {
    font-size: 18px;
    color: $accent;
    flex-shrink: 0;
  }
}
</style>
